<template>
  <section class="component-c669ebd7" resmed-component-name="sleep-blog">
    <!-- v-bind:class="{ 'ready': loaded }" -->
    <blog-breadcrumb
      v-if="query === 'tag'"
      v-bind:title="tags[tag]"
      style="margin-bottom: 2.5rem"
    ></blog-breadcrumb>

    <div class="component">
      <div class="container px-xs-sm-2">
        <!-- stage -->
        <div class="stage mt-5" v-images-loaded="imgsloaded">
          <masonry
            :cols="cols"
            :gutter="0"
            class="items"
            :class="{ ready: ready }"
          >
            <div class="item" v-for="(item, index) in items">
              <div class="card">
                <!-- brightcove video poster-frame -->
                <template v-if="item.brightcove.id && item.brightcove.player">
                  <a v-bind:href="item.permalink">
                    <div class="video" :class="`-mode-${$root.mode}`">
                      <figure class="embed-responsive embed-responsive-16by9">
                        <div
                          class="embed-responsive-item poster"
                          :style="{
                            'background-image': `url(${
                              brightcovePosterFrameMap[item.brightcove.id]
                            })`,
                          }"
                        ></div>
                        <div class="play-button"></div>
                      </figure>
                    </div>
                  </a>
                </template>

                <!-- gallery -->
                <template
                  v-if="
                    item.gallery &&
                    !item.brightcove.id &&
                    !item.brightcove.player
                  "
                >
                  <a
                    v-if="item.gallery.length === 1"
                    v-bind:href="item.permalink"
                  >
                    <figure>
                      <img
                        style="width: 100%"
                        v-bind:src="item.gallery[0].sizes.medium"
                        alt=""
                      />
                    </figure>
                  </a>

                  <template v-if="item.gallery.length > 1">
                    <gallery v-bind:items="item.gallery"></gallery>
                  </template>
                </template>

                <!-- placeholder -->
                <div
                  v-if="
                    !item.gallery &&
                    !item.brightcove.id &&
                    !item.brightcove.player
                  "
                  class="placeholder"
                >
                  <!--  -->
                </div>

                <div class="content">
                  <a v-bind:href="item.permalink">
                    <!-- <div class="meta mb-4" v-if="item.author || item.date"> -->
                    <!-- hold layout -->
                    <!-- <div class="author">
                        <template v-if="item.author">
                          by: {{ item.author }}
                        </template>
                      </div>
                      <time
                        class="date"
                        v-bind:datetime="item.post_date"
                        v-if="item.date"
                      >
                        {{ item.date }}
                      </time>
                    </div> -->
                    <h3 v-html="item.post_title"></h3>
                    <div class="excerpt mb-4">
                      <p>{{ item.post_excerpt | truncate(108) }}</p>
                    </div>
                  </a>

                  <!-- <div class="meta">
                    <ratings
                      v-bind:type="'blog-post'"
                      v-bind:id="item.ID.toString()"
                    ></ratings>
                    <div class="tags">
                      <a
                        v-for="(tag, index) in item.tags"
                        v-bind:href="`${address}?tags=${Object.keys(tag)[0]}`"
                        >{{ tag[Object.keys(tag)[0]] }} <span></span
                      ></a>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </masonry>

          <div class="load-more text-center" v-if="n > size" v-show="ready">
            <!-- size += ($root.mode === 'xs' || $root.mode === 'sm') ? 4 : 6 -->
            <a
              href="#"
              class="btn cta-pill hallow-red icon move-expand"
              v-on:click.prevent="size += 6"
              >Load more</a
            >
          </div>
        </div>
        <!-- end stage -->
      </div>
    </div>
  </section>
</template>

<script>
import imagesLoaded from "vue-images-loaded";
import { mapMutations } from 'vuex';
import gallery from "../shared-support/gallery-c669ebd7";

export default {
  name: "component-c669ebd7", // sleep-blog
  props: ["items", "query", "categories", "tags", "tag", "qty"],
  components: {
    gallery,
  },
  data() {
    return {
      cols: 3,
      active: "All",
      address: location.pathname,
      height: 0,
      ready: false,
      size: 12,
      n: 0,
      ul: {
        active: false,
      },
      brightcovePosterFrameMap: {},
      ids: this.items.map((a) => a.ID),
    };
  },
  computed: {
    filtered() {
      this.n = 0; // reset

      let arr = this.items.filter((item) => {
        if (this.active === "All") {
          this.n = this.items.length;
          return true;
        } else {
          let bool =
            item.category[Object.keys(item.category)[0]] === this.active;

          return bool && (this.n += 1);
        }
      });

      return this.chunks(arr, this.size);
    },
  },
  directives: {
    imagesLoaded,
  },
  methods: {
    ...mapMutations(['setShowLinks']),
    chunks(array, size) {
      let results = [];

      while (array.length) {
        results.push(array.splice(0, size));
      }
      return results;
    },
    imgsloaded(instance) {
      this.$nextTick(() => {
        this.ready = true;
      });
    },
    select(item, index) {
      if (
        this.active === item &&
        (this.$root.mode === "md" ||
          this.$root.mode === "lg" ||
          this.$root.mode === "xl")
      ) {
        return;
      }

      this.ul.active = !this.ul.active;

      this.active = item === this.active ? "All" : item;
      history.pushState("", "", "#" + index);
    },
  },
  watch: {
    "$root.mode": {
      handler(arg) {
        switch (arg) {
          case "xs":
          case "sm":
            this.cols = 1;
            break;

          case "md":
            this.cols = 2;
            break;

          default:
            this.cols = 3;
        }
      },
      immediate: true,
    },
  },
  filters: {
    truncate(string, length = 50) {
      if (!string || typeof string !== "string") {
        return "";
      }

      return string.length <= length
        ? string
        : string.substring(0, length) + "…";
    },
  },
  created() {
    // sessionStorage.setItem("showLinks", true);
    this.setShowLinks(true);
    this.size = this.$root.mode === "xs" || this.$root.mode === "sm" ? 6 : 12;

    if (this.query === "tag") {
      let key = location.search.split("=")[1],
        value = this.tags[key];

      localStorage.setItem(
        "sleep-blog-query-tag",
        JSON.stringify({ [key]: value })
      );
    } else {
      localStorage.removeItem("sleep-blog-query-tag");
    }

    let hash = window.location.hash.substring(1);
    if (hash !== "") {
      this.active = this.categories[hash];
    }

    this.items.forEach((item) => {
      if (item.brightcove && item.brightcove.player && item.brightcove.id) {
        axios
          .get(
            `//${location.hostname}/wp-json/resmed/v1/brightcove-thumbnail/${item.brightcove.id}`
          )
          .then((response) => {
            this.brightcovePosterFrameMap = {
              ...this.brightcovePosterFrameMap,
              [item.brightcove.id]: response.data.poster.src,
            };
          });
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/layout/sleep-blog";

.component-c669ebd7 {
  padding: 0 0 3rem 0;
}

.component {
  > .container {
    overflow: hidden;
  }

  .categories {
    margin-top: 3.5rem;
    margin-bottom: 1.5rem;

    opacity: 0;
    animation: fade-in 0.5s;
    animation-fill-mode: forwards;

    @media (min-width: 768px) {
      margin-bottom: 2rem;
    }

    p {
      @extend %body-small-bold;
      font-size: 12px;
      margin-bottom: 1rem;

      @media (min-width: 768px) {
        text-align: left;
      }
    }

    li {
      order: 2;

      a {
        @extend %body-small-bold;
        color: $cc-resmed-dark-grey;
        display: block;

        background-color: $cc-resmed-grey-15;
        padding: 1rem 1.75rem;
        transition: color 0.5s, background 0.5s;

        background-repeat: no-repeat;
        background-position: 0.5rem center;

        &:hover {
          color: $cc-resmed-white;
          background-color: $cc-resmed-action-red;
        }
      }

      &.is-active {
        order: 1;
        position: relative;

        &:before {
          content: "";
          position: absolute;
          border-left: 6px solid rgba(255, 255, 255, 0);
          border-right: 6px solid rgba(255, 255, 255, 0);
          border-top: 6px solid #1a76bc;
          right: 2rem;
          top: 48%;
          transform: translateY(-50%);
          transition: all 0.5s ease;
        }

        a {
          background-color: $cc-resmed-grey-15;
          color: $cc-resmed-black;
          border-radius: 6px;
          margin-bottom: 0.25rem;
          cursor: default;
        }
      }
    }

    ul {
      list-style: none;
      display: flex;
      flex-direction: column;

      @media (max-width: 767px) {
        &.is-active {
          li {
            display: list-item;
          }
        }

        li {
          display: none;

          &.is-active {
            display: list-item;
          }
        }
      }

      @media (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;

        li {
          order: 0 !important;
          margin: 0 1.25rem 1.25rem 0;

          a {
            padding: 0.5rem 1.75rem;
            border-radius: 21px !important;
            display: inline-block;
          }

          &.is-active {
            &:before {
              display: none;
            }

            a {
              background-color: $cc-resmed-action-red;
              background-image: url(#{$assets}/images/icon-active-button.svg);
              color: $cc-resmed-white;
              padding: 0.5rem 1.75rem 0.5rem 2.75rem;
            }
          }
        }
      }
    }
  }

  .stage {
    padding: 1rem 0;

    .results {
      margin-bottom: 0.75rem;

      h3 {
        margin-bottom: 0;
      }
    }

    .items {
      &.ready {
        animation: fade-in 0.25s;
        animation-delay: 0.75s;
        animation-fill-mode: forwards;
      }

      .item {
        padding: 0.25rem;

        @media (min-width: 992px) {
          padding: 0.5rem;
        }

        .card {
          @extend %cards-sleep-blog;

          .poster {
            background-size: cover;
            background-color: black;
          }

          .play-button {
            content: "";
            position: absolute;
            width: 100%;
            padding-top: 56.25%;
            z-index: 3;
            top: 0;
            background-image: url("#{$assets}/images/icon-play-button.svg");
            background-position: center center;
            background-repeat: no-repeat;
            background-size: 4rem 4rem;
            opacity: 0.925;
            transition: opacity 0.5s ease;
          }

          &:hover {
            h3 {
              color: $cc-resmed-pulse-blue;
            }
          }
        }
      }
    }

    .load-more {
      margin-top: 2rem;

      a {
        margin: 0 auto;
      }
    }
  }
}
</style>
